<script setup lang="ts">
import { toRaw } from 'vue';

const props = withDefaults(
  defineProps<{
    icon: Component;
    color?: 'primary' | 'secondary' | 'slate' | 'success' | 'warning' | 'danger' | 'info';
    iconClasses?: string;
  }>(),
  {
    color: 'slate'
  }
);

const styleClasses = computed(() => {
  return {
    primary: 'border-primary-200 bg-primary-100 text-primary-700',
    secondary: 'border-secondary-200 bg-secondary-100 text-secondary-700',
    slate: 'border-slate-200 bg-slate-100 text-slate-700',
    success: 'border-green-200 bg-green-100 text-green-700',
    warning: 'border-amber-200 bg-amber-100 text-amber-700',
    danger: 'border-red-200 bg-red-100 text-red-500',
    info: 'border-sky-200 bg-sky-100 text-sky-700'
  }[props.color];
});

const rawIcon = toRaw(props.icon);
</script>

<template>
  <div
    class="flex h-10 w-10 shrink-0 items-center justify-center rounded border"
    :class="styleClasses"
  >
    <component :is="rawIcon" class="h-4 w-4" :class="[iconClasses]" />
  </div>
</template>
